import { ApplicationRef, Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { interval, concat, timer, Subject, Subscription } from 'rxjs';
import { debounceTime, first, take, takeUntil } from "rxjs/operators";
// import { AlertService } from "@tt-lib/services/alert.service"
import { MatSnackBar } from "@angular/material/snack-bar";
// import { translate } from "ol/transform";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { NewversionDialogComponent } from './newversion-dialog/newversion-dialog.component';
import { TraceCreateConfirmationDialogComponent } from "@tt-lib/components/trace/trace-create/trace-create-confirmation-dialog/trace-create-confirmation-dialog.component";
import { BackEventService } from "@tt-lib/services/back-event.service";
import { Capacitor } from "@capacitor/core";

@Injectable({ providedIn: 'root' })

// install prompt for ios?
// https://medium.com/@oleksandr.k/a-way-to-show-a-prompt-to-install-your-angular-pwa-both-on-android-and-ios-devices-7a770f55c54

export class UpdateService {
  constructor(
    private appRef: ApplicationRef,
    private updates: SwUpdate,
    private dialog: MatDialog,
    private backEventService: BackEventService
  ) { }

  /**
   * @returns Subscription (calling class needs to unsubscribe afterwards)
   */
  initVersionUpdateChecks() {
    const subscriptions = new Subscription();
    //for isEnabled, see app.config.ts
    if (!this.updates.isEnabled || Capacitor.isNativePlatform()) {
      console.log(this.updates.isEnabled ? 'service worker for updates enabled in config, but we will not subscribe to update events for native apps' : 'service worker for updates not enabled in config');
    } else {
      const hours = 1;
      console.log(`setting up scheduled task for pwa : checking for new app version every ${hours} hours`);
      const appIsStable$ = this.appRef.isStable.pipe(first(isStable => isStable === true));
      const everySixHours$ = interval(hours * 60 * 60 * 1000);//every x hours
      const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);
      subscriptions.add(everySixHoursOnceAppIsStable$.subscribe(() => {
        this.updates.checkForUpdate().then((res) => {
        });
      }));

      subscriptions.add(this.updates.versionUpdates.subscribe(async evt => {
        //console.log('UpdateService: versionUpdates', evt);
        switch (evt.type) {
          case 'VERSION_DETECTED':
            //console.log(`Downloading new app version: ${evt.version.hash}`);
            break;
          case 'VERSION_READY':
            //console.log(`Current app version: ${evt.currentVersion.hash}`);
            //console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
            this.promptUser();
            break;
          case 'VERSION_INSTALLATION_FAILED':
            //console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
            break;
        }
      }));
    }

    return subscriptions;
  }

  promptUser() {
    let snackbarDialog = this.dialog.open(NewversionDialogComponent, {
      panelClass: 'newversion-dialog',
      position: { bottom: '20px' }, // only bottom, no left/right
      hasBackdrop: false,
    });

    snackbarDialog.afterClosed().pipe(take(1)).subscribe(async () => {
      //await this.updates.activateUpdate();
      window.location.reload();
    });

    this.backEventService.registerOpenedWindow({ windowName: 'NewversionDialogComponent', isAutoCloseableWindow: true });
  }
}